let currentConfirmCallback = null

const open = (options = {}) => {
  const title = options.title || "Подтвердите действие"
  const message = options.message || "Вы уверены, что хотите выполнить это действие?"
  const confirmText = options.confirmText || "Подтвердить"
  const cancelText = options.cancelText || "Отмена"

  document.querySelector(".modal-v2_title").textContent = title
  document.querySelector(".modal-v2_message").textContent = message
  document.querySelector(".modal-v2_btn-confirm").textContent = confirmText
  document.querySelector(".modal-v2_btn-cancel").textContent = cancelText

  currentConfirmCallback = options.onConfirm

  document.getElementById("overlay-v2").classList.add("active")
}

const closeModal = () => {
  document.getElementById("overlay-v2").classList.remove("active")
  currentConfirmCallback = null
}

const closeModalOnOverlay = (event) => {
  if (event.target === event.currentTarget) {
    closeModal()
  }
}

const confirmAction = () => {
  if (currentConfirmCallback && typeof currentConfirmCallback === "function") {
    currentConfirmCallback()
  }
  closeModal()
}

export const Modal = {
  open,
  closeModal,
  closeModalOnOverlay,
  confirmAction,
}
